<template>
  <div class="engineering">
    <el-container>
      <el-main ref="main" style="height: 80%">
        <div class="moduleList">
          <delete-module
            class="deleteModule"
            :list.sync="engineerList.laborActList"
            :index="3"
            titleTxt="劳务信息"
            :isShowBtn="true"
            @refreshDataList="getFrontDetail"
          ></delete-module>
          <delete-module
            class="deleteModule"
            :list.sync="engineerList.materialActList"
            :index="3"
            titleTxt="材料信息"
            :isShowBtn="true"
            @refreshDataList="getFrontDetail"
          ></delete-module>
          <delete-module
            class="deleteModule"
            :list.sync="engineerList.machineActList"
            :index="3"
            titleTxt="机械信息"
            :isShowBtn="true"
            @refreshDataList="getFrontDetail"
          ></delete-module>
          <delete-module
            v-if="type == 'MEASURE'"
            class="deleteModule"
            :list.sync="engineerList.otherActList"
            :index="3"
            titleTxt="其他"
            :isShowBtn="true"
            @refreshDataList="getFrontDetail"
          ></delete-module>
        </div>
      </el-main>
      <el-footer class="container" style="margin-top: 30px">
        <div class="btnMid">
          <el-button type="info" @click="reset()">关 闭</el-button>
          <!--                <el-button type="primary" @click="submit()">提 交</el-button>-->
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import deleteModule from "../delete-module";
import {
  queryOtherListService,
  queryMeasureDetailService,
} from "../../../services/feeServices";
export default {
  name: "otherDeleteDetail",
  data() {
    return {
      activeName: "Tab1",
      type: "DIRECT",
      projectDetailsFrontId: "",
      engineerList: [],
      partyBId:0,
      id:0,
    };
  },
  components: {
    deleteModule,
  },
  methods: {
    onActive(menuCode) {
      this.id = this.tabRouteParam.id;
      this.partyBId = this.tabRouteParam.partyBId;
      this.type = this.tabRouteParam.type;
      this.getFrontDetail();
    },
    getFrontDetail() {
      let paramsData = {};
      if (this.type == "MEASURE") {        
        paramsData.partyBId=this.partyBId
        paramsData.id=this.id
        queryMeasureDetailService(paramsData)
          .then((res) => {
            if (res.code == 10000000) {
              this.engineerList = res.data|| {};
              this.$forceUpdate();
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((error) => {
            this.$message.error("网络请求失败");
          });
      } else {
        // paramsData.partyBId=this.partyBId
        paramsData.id=this.id
        queryOtherListService(paramsData)
          .then((res) => {
            if (res.code == 10000000) {
              this.engineerList = res.data[0] || {};
              this.$forceUpdate();
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((error) => {
            this.$message.error("网络请求失败");
          });
      }
    },
    reset() {
      this.bus.$emit("tabClose", "directDeleteDetail");
      if (this.type == "MEASURE") {
        this.bus.$emit("navMenuChange", {
          routeId: "measureFee",
        });
      } else if (this.type == "DIRECT") {
        this.bus.$emit("navMenuChange", {
          routeId: "otherDirectFee",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.engineering {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  .container {
    width: 900px;
    .btnMid {
      width: 300px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
    }
  }
}
.partyBName {
  width: 300px;
  font-size: 18px;
  font-weight: 600;
}
.moduleList {
  width: 90%;
  .deleteModule {
    width: 100%;
  }
}
.noDataTxt {
  height: 100%;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/.el-tabs__item {
  padding: 0 20px !important;
}
</style>

